export default __webpack_public_path__ + "static/media/Timetable_logo_green.1a503222.svg";